const scrollToBlockId = (hash: string) => {
  const matchingElement =
    document.querySelector(`[blockid='${hash.substring(1)}']`) ||
    document.querySelector(`[data-blockid='${hash.substring(1)}']`)

  matchingElement?.scrollIntoView()
}

export { scrollToBlockId }
